export default __webpack_public_path__ + "static/media/circle-plus.57f8fd10.svg";